import { Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';
import { IoClose } from 'react-icons/io5';
import { TrialProgramImage } from '@ui';
import { OrganType, Randomization } from '@/api/apis/case';
import { formatDate } from '@/utils/helpers';
import SectionRow from '../SectionRow';
import { randomizationTypeNames } from '@/constants/case/case.constants';

type RandomizationResultsModalProps = {
  txCenterName?: string;
  onClose: () => void;
  organType: OrganType;
  randomization: Randomization;
};

export const RandomizationResultsModal = ({
  onClose,
  organType,
  txCenterName,
  randomization,
}: RandomizationResultsModalProps) => {
  const { randomizationDateTime, timeZone, txCenterRepresentativeName, result } = randomization;

  return (
    <Modal
      className="scroll"
      isOpen
      onClose={onClose}
      size="xl"
      closeButton={<IoClose size={42} className="z-1000" />}
      classNames={{
        closeButton: 'text-base-10 mt-6 mr-4',
        header: 'text-hl! flex flex-col gap-4 text-base-20 pt-6 pb-4',
        body: 'flex flex-col mx-6 p-0 pb-6 gap-6',
      }}
    >
      <ModalContent>
        <ModalHeader>
          <div className="flex gap-2 items-center">
            <div className="font-secondary">Randomization Results</div>
            <TrialProgramImage organ={organType} />
          </div>
          <Divider />
        </ModalHeader>
        <ModalBody>
          <SectionRow label="Randomization Date & Time">
            {formatDate(randomizationDateTime, 'MM/dd/yyyy HH:mm zzz', { timezone: timeZone })}
          </SectionRow>
          <SectionRow label="TX Center Representative" truncate={false}>
            {txCenterRepresentativeName}
          </SectionRow>
          <SectionRow truncate={false} label="TX Center">
            {txCenterName ?? '-'}
          </SectionRow>
          <SectionRow label="Randomization Result">{randomizationTypeNames[result]}</SectionRow>
        </ModalBody>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
